import {
    EpgProgram,
    MixedItem,
    RBLink,
    RBProgram,
    SearchProgram,
} from 'store/railsBuilder/reducer.types';

import getDeeplinkItem from 'utils/getDeeplinkItem';
import { DeeplinkParams, LinkParams } from 'utils/openDeeplink';

export default function getOpeningParams(
    item: EpgProgram | RBProgram | MixedItem | SearchProgram,
): DeeplinkParams & {
    deeplink?: string;
    link: RBLink;
} {
    const link = getDeeplinkItem(item)!;

    const deeplinkParams =
        link &&
        JSON.parse(link.playbackParams).reduce(
            (
                acc: LinkParams,
                currentParam: { key: string; value: string },
            ) => ({
                ...acc,
                [currentParam.key]: currentParam.value,
            }),
            {},
        );

    return {
        appleAppId: deeplinkParams?.appleAppId,
        androidMobileBundleId: deeplinkParams?.androidMobileBundleId,
        link,
    };
}
